import { createBigDecimal } from '@0xtorch/big-decimal'
import z from 'zod'

export const decimalSchema = z
  .string()
  .regex(/^-?\d+(\.\d+)?$/)
  .transform((v) => createBigDecimal(v))

export const blankableDecimalSchema = z.union([
  decimalSchema,
  z.literal('').transform(() => createBigDecimal(0n)),
])
